import { createSlice } from "@reduxjs/toolkit";
import { getAuditions } from "./thunk";

export interface IState {
  Auditions: any;
  isAuditionLoading: boolean;
  isAuditionSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  Auditions: null,
  isAuditionLoading: false,
  isAuditionSuccess: false,

  error: {},
};

const AuditionSlice = createSlice({
  name: "Auditions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Audition
    builder.addCase(getAuditions.pending, (state: IState, action: any) => {
      state.isAuditionLoading = true;
    });
    builder.addCase(getAuditions.fulfilled, (state: IState, action: any) => {
      state.Auditions = action.payload?.data;
      state.isAuditionSuccess = true;
      state.isAuditionLoading = false;
    });
    builder.addCase(getAuditions.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isAuditionSuccess = false;
      state.isAuditionLoading = false;
    });

  },
});

export default AuditionSlice.reducer;